import React from 'react';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

interface Props {
	enableRowDragAndDrop: boolean;
	gridColumn?: number;
	rowStyles?: React.CSSProperties;
}

export const MantineTableDragHandle: React.FC<Props> = ({
	enableRowDragAndDrop,
	gridColumn,
	rowStyles = {},
}) => {
	if (!enableRowDragAndDrop) {
		return null;
	}

	return (
		<div
			style={{
				...(gridColumn && { gridColumn }),
				...rowStyles,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '8px',
				cursor: 'grab',
				color: defaultTheme.v3.colors.gray[6],
			}}
		>
			<Icon variant="drag-indicator" size="sm" />
		</div>
	);
};
